import React, { useState } from "react";
import PropTypes from "prop-types";
import { List, ListItemButton, Collapse } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import SidenavCollapse from "common/Sidenav/SidenavCollapse";
import styles from "common/Sidenav/styles/nestedSidenavCollapse";

function NestedSidenavCollapse({ name, icon, active, children }) {
  const [open, setOpen] = useState(active);
  const classes = styles();

  const handleToggle = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };

  return (
    <div className={classes.nestedContainer}>
      <ListItemButton onClick={handleToggle} className={classes.nestedItem}>
        <SidenavCollapse name={name} icon={icon} noCollapse={false} active={active} />
        <div className={`${classes.expandIcon} ${open ? classes.expandIconOpen : ""}`}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </div>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit className={classes.nestedCollapse}>
        <List component="div" disablePadding>
          {React.Children.map(children, (child) => (
            <div className={classes.childItem}>{child}</div>
          ))}
        </List>
      </Collapse>
    </div>
  );
}

NestedSidenavCollapse.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  active: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default NestedSidenavCollapse;
